import React, { forwardRef } from 'react';

interface EditableFieldProps {
  value: string;
  onChange: (value: string) => void;
  onCancel: () => void;
  onSave: () => void;
}

// eslint-disable-next-line react/display-name
const EditableField = forwardRef<HTMLTextAreaElement, EditableFieldProps>(
  ({ value, onChange, onCancel, onSave }, textareaRef) => {
    return (
      <div className="flex flex-col bg-white px-2 border border-gray-200 rounded-md">
        <textarea
          className="focus text-sm font-lato font-normal text-black leading-[1.4] break-words p-2 border-0 focus:outline-none outline-none focus:ring-0 resize-none"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          ref={textareaRef}
        />
        <div className="flex justify-end mt-2 text-sm pb-2">
          <button className="bg-gray-100 px-3 py-1 mr-2 rounded" onClick={onCancel}>
            Cancel
          </button>
          <button
            className={`px-3 py-1 rounded ${
              !value ? 'bg-gray-400 text-gray-200 cursor-not-allowed' : 'bg-[#0979b7] text-white'
            }`}
            onClick={onSave}
            disabled={!value}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
);

export default EditableField;
